import { Select, Tag } from "antd";
import React from "react";

const STATUS = {
  INPR: {
    label: "In progress",
    value: "INPR",
  },
  S: {
    label: "Sent",
    value: "S",
    color: "cyan",
  },
  RECVD: {
    label: "Received",
    value: "RECVD",
    color: "blue",
  },
  FG: {
    label: "Fail Gateway",
    value: "FG",
    color: "red",
  },
  FO: {
    label: "Fail Operator",
    value: "FO",
    color: "red",
  },
  A: {
    label: "Anti Spam",
    value: "A",
    color: "purple",
  },
  FM: {
    label: "Fail Mobile",
    value: "FM",
    color: "geekblue",
  },
  B: {
    label: "Blacklist",
    value: "B",
  },
  E: {
    label: "Expired",
    value: "E",
  },
};

const SelectAntdOptions = () => {
  return Object.keys(STATUS).map((s) => (
    <Select.Option key={s} value={s}>
      <Tag color={STATUS[s]["color"] || ""}>{STATUS[s]["label"]}</Tag>
    </Select.Option>
  ));
};

export { SelectAntdOptions, STATUS };



// WEBPACK FOOTER //
// ./src/config/messageStatus.js